<div class="manage-fund-container">
  <div class="container-fluid px-1">
    <div class="row">
      <div class="col-12">
        <div class="toggle-actions-blk my-2">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button
              type="button"
              class="btn btn-outline-primary"
              [ngClass]="{ active: isAddFunds }"
              (click)="onAddFunds()"
            >
            <span translate class="translate">pages.newRetailer.add</span>
            </button>
            <button
              type="button"
              class="btn btn-outline-primary"
              [ngClass]="{ active: isRemoveFunds }"
              (click)="onRemoveFunds()"
            >
            <span translate class="translate">pages.newRetailer.remove</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <mat-card class="p-2 shadow">
    <div class="add-fund-form-container">
      <form (ngSubmit)="onAddFundSubmit()" [formGroup]="manageAdminFundsForm">
        <div class="form-inner  content-details-blk">
          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>Retailer Account Number</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{'pages.Managefunds.AccountNumber' | translate }}</mat-label>
                  <input
                    type="text"
                    placeholder="Pick one"
                    aria-label="Number"
                    matInput
                    formControlName="accountNumber"
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="selectedAccountNumber($event)" 
                    [displayWith]="getOptionText"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptions"
                      [value]="option"
                    >
                      {{ option.retailerAccountNum }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>{{'pages.AutoReload.RetailerName' | translate }}</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <mat-label>{{'pages.AutoReload.RetailerName' | translate }} </mat-label>
                  <input
                    type="text"
                    placeholder="Pick one"
                    aria-label="Number"
                    matInput
                    formControlName="retailerName"
                    [matAutocomplete]="auto1"
                  />
                  <mat-autocomplete
                    #auto1="matAutocomplete"
                    (optionSelected)="selectedRetailerName($event)"
                    [displayWith]="getOptionretailerName"
                  >
                    <mat-option
                      *ngFor="let option of filteredOptions"
                      [value]="option"
                    >
                      {{ option.retailerName }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <div *ngIf="f.retailerName.touched && f.retailerName.invalid">
                  <div *ngIf="f.retailerName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      Retailer Name Is Required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate><span translate class="translate">pages.newRetailer.accountType</span></h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'pages.newRetailer.accountType' | translate }}"
                    formControlName="retailerType"
                    readonly
                  />
                </mat-form-field>
                <div *ngIf="f.retailerType.touched && f.retailerType.invalid">
                  <div *ngIf="f.retailerType.errors.required">
                    <mat-hint class="text-danger ms-2">
                      Retailer Type Is Required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>{{'pages.ManageProviders.Mobilenumber' | translate }}</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    placeholder="{{'pages.ManageProviders.Mobilenumber' | translate }}"
                    formControlName="mobileNumber"
                    readonly
                  />
                </mat-form-field>
                <div *ngIf="f.mobileNumber.touched && f.mobileNumber.invalid">
                  <div *ngIf="f.mobileNumber.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{ 'pages.placeholders.MobileNumberisrequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>{{ 'pages.placeholders.BusinessName' | translate }}</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <!-- <mat-form-field appearance="outline">
                      <mat-select formControlName="businessName" required>
                        <mat-option >
                         Grocery
                        </mat-option>
                      </mat-select>
                    </mat-form-field> -->

                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'pages.newRetailer.dbaName' | translate }}"
                    readonly
                    formControlName="businessName"
                  />
                </mat-form-field>
                <div *ngIf="f.businessName.touched && f.businessName.invalid">
                  <div *ngIf="f.businessName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{ 'pages.placeholders.Businessnameisrequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate><span translate>pages.newRetailer.dbaName</span></h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    type="text"
                    placeholder="{{ 'pages.newRetailer.dbaName' | translate }}"
                    readonly
                    formControlName="dbaName"
                  />
                </mat-form-field>
                <div *ngIf="f.dbaName.touched && f.dbaName.invalid">
                  <div *ngIf="f.dbaName.errors.required">
                    <mat-hint class="text-danger ms-2">
                      {{'pages.placeholders.DBANameisrequired' | translate }}</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.address</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    type="text"
                    readonly
                    placeholder="{{'pages.AddProviders.Enteraddress' | translate }} Line1"
                    formControlName="address1"
                  />
                </mat-form-field>
                <div *ngIf="f.address1.touched && f.address1.invalid">
                  <div *ngIf="f.address1.errors.required">
                    <mat-hint class="text-danger ms-2">
                      Address1 Is Required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
             <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.amount<span class="required">*</span>
              </h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: numberMask, guide: false }"
                    required
                    placeholder="{{'pages.Managefunds.Enteramount' | translate }}"
                    (keyup)="keyUpEvent($event)"
                    formControlName="amount"
                  />
                </mat-form-field>
                <div *ngIf="f.amount.touched && f.amount.invalid">
                  <div *ngIf="f.amount.errors.required; else invalid">
                    <mat-hint class="text-danger ms-2">
                      Amount Is Required.</mat-hint
                    >
                  </div>
                  <ng-template #invalid>
                    <mat-hint class="text-danger ms-2">
                      Invalid Amount Entered.</mat-hint
                    >
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <div class="row my-2">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>
                pages.newRetailer.availableCreditBalance
              </h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: numberMask, guide: false }"
                    readonly
                    placeholder="{{'pages.Managefunds.EnterCreditbalance' | translate }}"
                    formControlName="currentAmount"
                  />
                </mat-form-field>
                <div *ngIf="f.currentAmount.touched && f.currentAmount.invalid">
                  <div *ngIf="f.currentAmount.errors.required">
                    <mat-hint class="text-danger ms-2">
                      Current Amount Is Required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
             <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <h4 class="form-item-label" translate>pages.newRetailer.newBalance</h4>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
              <div class="form-item-input">
                <mat-form-field class="" appearance="outline">
                  <input
                    matInput
                    [textMask]="{ mask: numberMask, guide: false }"
                    readonly
                    placeholder="{{'pages.Managefunds.Enterbalance' | translate }}"
                    formControlName="newBalance"
                  />
                </mat-form-field>
                <div *ngIf="f.newBalance.touched && f.newBalance.invalid">
                  <div *ngIf="f.newBalance.errors.required">
                    <mat-hint class="text-danger ms-2">
                      New Balance Is Required.</mat-hint
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-footer mb-4">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <button
                mat-raised-button
                [disabled]="!manageAdminFundsForm.valid"
                color="primary"
                type="submit"
                class="rounded-0"
              >
                <span translate *ngIf="isAddFunds">pages.newRetailer.addFunds</span>
                <span translate *ngIf="isRemoveFunds">pages.newRetailer.removeFunds</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
                mat-stroked-button
                color="primary"
                type="button"
                class="rounded-0"
                (click)="onCancel()"
              >
              <span translate class="translate">pages.newRetailer.cancel</span>
              </button>
            </li>
            <li class="list-inline-item"></li>
          </ul>
        </div>
      </form>
    </div>
  </mat-card>
</div>
